__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/43b4d13/_next/";